import i18n from '@Lang'

export const clone = (obj) => {
  let o
  if (typeof obj === 'object') {
    if (obj === null) {
      o = null
    } else {
      if (obj instanceof Array) {
        o = []
        for (let i = 0, len = obj.length; i < len; i++) {
          o.push(clone(obj[i]))
        }
      } else {
        o = {}
        for (var j in obj) {
          o[j] = clone(obj[j])
        }
      }
    }
  } else {
    o = obj
  }
  return o
}

export const removeRepeat = (arr) => {
  return Array.from(new Set(arr))
}

export const formatCsvData = (data) => {
  return String(data)
    .replace(/"/g, '""')
    .replace(/(^[\s\S]*$)/, '"$1"')
}

export function buildTree(list) {
  const map = {}
  list.forEach((item) => {
    if (!map[item.id]) {
      map[item.id] = item
    }
  })
  list.forEach((item) => {
    if (item.parentId !== -1) {
      map[item.parentId].children ? map[item.parentId].children.push(item) : (map[item.parentId].children = [item])
    }
  })
  return list.filter((item) => {
    if (item.parentId === -1) {
      return item
    }
  })
}

export function norlizeColumns(columnKeys, columnsMaps) {
  const columns = []
  for (const columnName of columnKeys) {
    const c = columnName.split(',')
    if (c[0] === 'index' || c[0] === 'selection') {
      columns.push({
        sequence: c[0],
        label: c[0] === 'index' ? i18n.t('public.order') : '',
        width: parseInt(String(c[1]).trim())
      })
    } else if (c[0] === 'image') {
      columns.push({
        image: true,
        prop: c[1].trim(),
        label: columnsMaps.get(c[1].trim()),
        width: parseInt(c[2]) || 'auto'
      })
    } else {
      const cf = {
        prop: c[0],
        label: columnsMaps.get(c[0]),
        width: parseInt(c[1]) || 'auto'
      }
      if (cf.label instanceof Object) {
        cf['formatter'] = cf.label.formatter
        cf.label = cf.label.label
      }
      columns.push(cf)
    }
  }
  return columns
}
